"use client";
import React from "react";
import * as _Builtin from "./_Builtin";
import * as _utils from "./utils";
import _styles from "./DevlinkSkuGrid4Columns.module.css";

export function DevlinkSkuGrid4Columns({
  as: _Component = _Builtin.Block,
  displayGridTitle = true,
  displayGridProminentTitle = true,
  gridTitle = "Select a service",
  gridTitleClass = "h1",
  skuGrid,
  gridTitleStyle = {},
}) {
  return (
    <_Component tag="div">
      {displayGridTitle ? (
        <_Builtin.Block tag="div">
          <_Builtin.Heading
            className={_utils.cx(_styles, "txt-header-sm")}
            tag="h2"
          >
            {gridTitle}
          </_Builtin.Heading>
          <_Builtin.Block className={_utils.cx(_styles, "small-1")} tag="div" />
        </_Builtin.Block>
      ) : null}
      {displayGridProminentTitle ? (
        <_Builtin.Block tag="div">
          <_Builtin.Heading
            className={_utils.cx(_styles, "txt-title")}
            tag="h2"
          >
            {gridTitle}
          </_Builtin.Heading>
          <_Builtin.Block className={_utils.cx(_styles, "small-1")} tag="div" />
        </_Builtin.Block>
      ) : null}
      <_Builtin.Block className={_utils.cx(_styles, "col-4")} tag="div">
        {skuGrid}
      </_Builtin.Block>
    </_Component>
  );
}
